// Fix 22 — Convert an ISO 3166-1 alpha-2 country code to its flag emoji
// via the Unicode regional-indicator offset (0x1F1E6 = 'A').  Returns
// "" when the code is missing/invalid so callers can render the
// country name alone without breaking the section.
export function flagFromCode(cc) {
  const s = String(cc || "").trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(s)) return "";
  const A = 0x1F1E6;
  return String.fromCodePoint(A + s.charCodeAt(0) - 65)
       + String.fromCodePoint(A + s.charCodeAt(1) - 65);
}
